import SOCKET_OPTIONS from "../socket-variables";
import {io, Socket} from "socket.io-client";

// Export the socket factory instead of an instance
export function createSocket(): Socket {
    return io(SOCKET_OPTIONS.hostname, SOCKET_OPTIONS);
}

// Export a ref that will hold the socket instance
export let socket: Socket | null = null;

export function setSocket(socketInstance: Socket) {
    socket = socketInstance;
}